// SCR-STAFF-921 — جزئیات کارکن و ارائه‌دهنده (US-IAM-020 تا 025): تب‌های پروفایل سازمانی، دسترسی (نقش‌ها و شعب) و
// ارائه‌دهنده؛ اقدام‌های چرخه عمر عضویت در سربرگ.
import Stack from '@mui/material/Stack';
import { unwrap } from '@phoenix/api-client';
import { useTenantSession } from '@phoenix/auth';
import { useTranslation } from '@phoenix/i18n';
import { DetailPage, KeyValueList, StatusChip } from '@phoenix/ui';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useParams } from 'react-router';
import { AccessTab } from './AccessTab';
import { iamKeys, maskMobile, membershipTone } from './common';
import { MemberActions } from './MemberActions';
import { ProfileTab } from './ProfileTab';
import { ProviderTab } from './ProviderTab';

export const SCR_STAFF_921 = 'SCR-STAFF-921';

/** `membershipId`: نمایش درون صفحه دیگر (پنل Setup Wizard)؛ وگرنه از مسیر `/settings/staff/:membershipId`. */
export function StaffDetailPage({ membershipId: embeddedId }: { membershipId?: string } = {}) {
  const { t } = useTranslation('iam');
  const params = useParams();
  const membershipId = embeddedId ?? params['membershipId'] ?? '';
  const { tenantApi, session } = useTenantSession();
  const [tab, setTab] = useState('profile');

  const member = useQuery({
    queryKey: iamKeys.membership(session?.tenantId, membershipId),
    queryFn: () =>
      unwrap(tenantApi.GET('/api/v1/identity/memberships/{id}', { params: { path: { id: membershipId } } })),
  });
  const data = member.data;

  return (
    <DetailPage
      screenId={SCR_STAFF_921}
      isLoading={member.isPending}
      error={member.error}
      onRetry={() => void member.refetch()}
      titleKey="iam:detail.title"
      titleValues={{ name: data?.displayName ?? '' }}
      badges={
        data ? (
          <span data-testid="member-status" data-status={data.status}>
            <StatusChip tone={membershipTone(data.status)} labelKey={`iam:status.${data.status}`} />
          </span>
        ) : undefined
      }
      actions={data ? <MemberActions member={data} /> : undefined}
      activeTab={tab}
      onTabChange={setTab}
      tabs={
        data
          ? [
              {
                id: 'profile',
                labelKey: 'iam:detail.tabs.profile',
                content: (
                  <Stack spacing={2}>
                    <KeyValueList
                      columns={3}
                      items={[
                        {
                          labelKey: 'iam:staff.columns.mobile',
                          value: <bdi dir="ltr">{maskMobile(data.mobile)}</bdi>,
                          testId: 'member-mobile',
                        },
                        {
                          labelKey: 'iam:detail.status_reason',
                          value: data.statusReason,
                          testId: 'member-status-reason',
                        },
                        {
                          labelKey: 'iam:staff.columns.provider',
                          value: data.providerId
                            ? t(`iam:provider.status.${data.providerStatus ?? 'Inactive'}`)
                            : t('iam:detail.not_provider'),
                        },
                      ]}
                    />
                    <ProfileTab member={data} />
                  </Stack>
                ),
              },
              { id: 'access', labelKey: 'iam:detail.tabs.access', content: <AccessTab member={data} /> },
              {
                id: 'provider',
                labelKey: 'iam:detail.tabs.provider',
                content: <ProviderTab member={data} />,
              },
            ]
          : []
      }
    />
  );
}
